import { StoreAction } from "../../../types/store"
import { Program } from "../lib/program";

export type SetProgramsAction = StoreAction & { programs: Program[] }
export const SET_PROGRAMS = "SET_PROGRAMS"
export const setPrograms = (programs: Program[]): SetProgramsAction => ({
  type: SET_PROGRAMS,
  programs,
})
